/**
 * Cannot decrement availability due to insufficient stock or invalid request parameters.
 */
export class DecrementNotPossibleWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('DecrementNotPossible');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'DECREMENT_NOT_POSSIBLE';
    this.name = 'DecrementNotPossible';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'DecrementNotPossible',
      applicationCode: 'DECREMENT_NOT_POSSIBLE',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Cannot increment availability due to invalid request parameters.
 */
export class IncrementNotPossibleWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('IncrementNotPossible');

    this.httpCode = 428;
    this.statusCode = 'FAILED_PRECONDITION';
    this.applicationCode = 'INCREMENT_NOT_POSSIBLE';
    this.name = 'IncrementNotPossible';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'IncrementNotPossible',
      applicationCode: 'INCREMENT_NOT_POSSIBLE',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}
